<template>
    <div id="settings-selector-container" v-if="this.tab == 'settings'">
        <div class="tabs-container noselect">
            <!--
            <div class="tab-holder tab-active">
                <a>Display</a>
            </div>
            <div class="tab-holder tab-active">
                <a>Hotkeys</a>
            </div>
            <div class="tab-holder tab-active">
                <a>Chat</a>
            </div>
            -->
        </div>
        <div class="settings-widget-container">
            <div id="display-settings-container">
                <!--
                <div class="option-row">
                    <span class="option-text">Controls size</span>
                    <select @change="changeControlSize">
                        <option value="big" :selected="this.state.control_size == 'big'">Big</option>
                        <option value="small" :selected="this.state.control_size == 'small'">Small</option>
                    </select>
                </div>
                -->
                <div class="option-row">
                    <span class="option-text">Graph mode</span>
                    <select @change="changeGraphMode">
                        <option value="graphics" :selected="this.state.graph_mode == 'graphics'">Graphics</option>
                        <option value="text" :selected="this.state.graph_mode == 'text'">Text (Low CPU usage)</option>
                    </select>
                </div>
            </div>
            <div id="hotkeys-settings-container">
                hotkeys-settings-container
            </div>
            <div id="chat-settings-container">
                chat-settings-container
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "settings",
        props: ['state', 'tab'],
        created() {

        },
        mounted() {
            EventBus.$emit('push_component', 'settings');
            // this.render();
        },
        beforeUpdate() {
            // console.log('player-container before update');
        },
        updated() {
            // console.log('player-container update');
        },
        methods: {
            changeGraphMode(e)
            {
                this.state.graph_mode = e.target.value;
                if (this.state.graph_mode == 'text') {
                    EventBus.$emit('stop_rendering');
                } else {
                    EventBus.$emit('start_rendering');
                }
            },
            changeControlSize(e)
            {
                this.state.control_size = e.target.value;
            }
        },
    }
</script>

<style scoped>

</style>
